import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { KeyValueEnum } from "../models/common";
import { Result } from "../models/common/resultResponse";
import { IEntityTypeApi } from "./base/registration/entityTypeApi";

const baseRoute: string = "EntityType";

export class EntityTypeApi extends IEntityTypeApi {
	getDomain(): Promise<AxiosResponse<Result<KeyValueEnum[]>>> {
		return api.get(`${baseRoute}/domain`);
	}
}
